import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import { LanguageProvider } from "./lib/i18n";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Rooms from "./pages/Rooms";
import Amenities from "./pages/Amenities";
import Location from "./pages/Location";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const ProtectedRoute = ({ children }) => {
    const { admin, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="overline text-muted-foreground">Loading…</div>
            </div>
        );
    }
    if (!admin) return <Navigate to="/admin/login" replace />;
    return children;
};

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <LanguageProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route element={<Layout />}>
                                <Route path="/" element={<Home />} />
                                <Route path="/gallery" element={<Gallery />} />
                                <Route path="/rooms" element={<Rooms />} />
                                <Route
                                    path="/amenities"
                                    element={<Amenities />}
                                />
                                <Route path="/location" element={<Location />} />
                                <Route path="/contact" element={<Contact />} />
                            </Route>
                            <Route
                                path="/admin/login"
                                element={<AdminLogin />}
                            />
                            <Route
                                path="/admin/dashboard"
                                element={
                                    <ProtectedRoute>
                                        <AdminDashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </BrowserRouter>
                    <Toaster
                        position="top-center"
                        toastOptions={{
                            style: {
                                fontFamily: "'Outfit', sans-serif",
                                borderRadius: 2,
                            },
                        }}
                    />
                </LanguageProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
